export const bookingTranslations = {
  en: {
    breadcrumb: { home: 'Home', bookNow: 'Book Now' },
    hero: {
      title: 'Book Your Training Camp',
      subheading: 'Complete the form below and our team will contact you within 24 hours',
      description: "Choose your preferred facility, dates, and training requirements. We'll handle everything else.",
    },
    success: {
      title: 'Thank You! Booking Request Received',
      message: "We've received your booking request. Our team will shortly contact you to confirm details and provide a quote.",
      returnHome: 'Return to Homepage',
    },
    sections: {
      contact: 'Contact Information',
      trainingCamp: 'Training Camp Details',
      packageServices: 'Package & Services Required',
      additional: 'Additional Details',
    },
    labels: {
      fullName: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      organization: 'Organization/Team Name',
      country: 'Country',
      sport: 'Sport/Discipline',
      location: 'Preferred Location',
      numAthletes: 'Number of Athletes',
      numCoaches: 'Number of Coaches/Staff',
      startDate: 'Preferred Start Date',
      endDate: 'Preferred End Date',
      packageType: 'Package Type',
      servicesNeeded: 'Services Needed',
      accommodationType: 'Accommodation Type',
      mealPreferences: 'Meal Preferences',
      specialRequirements: 'Special Requirements or Requests',
      hearAboutUs: 'How did you hear about us?',
      budgetRange: 'Budget Range (optional)',
    },
    placeholders: {
      fullName: 'Your full name',
      email: 'your.email@example.com',
      phone: '+359 XXX XXX XXX',
      organization: 'Your team or organization name',
      country: 'Select your country',
      sport: 'Select sport/discipline',
      sportOther: 'Please specify',
      location: 'Select preferred location',
      numAthletes: 'e.g., 20',
      numCoaches: 'e.g., 3',
      specialRequirements: 'Please share any specific requirements, training goals, special needs, or questions you have...',
      hearAboutUs: 'Select an option',
      budgetRange: 'Select budget range',
      foodAllergies: 'Please specify food allergies',
    },
    errors: {
      fullNameRequired: 'Full name is required',
      emailRequired: 'Email is required',
      emailInvalid: 'Please enter a valid email address',
      phoneRequired: 'Phone number is required',
      sportRequired: 'Please select a sport/discipline',
      locationRequired: 'Please select a preferred location',
      numAthletesRequired: 'Please enter number of athletes (minimum 1)',
      startDateRequired: 'Start date is required',
      endDateRequired: 'End date is required',
      endDateAfterStart: 'End date must be after start date',
      privacyRequired: 'You must agree to the privacy policy',
    },
    duration: 'Duration:',
    nights: 'nights',
    days: 'days',
    required: '*',
    // Package types (value is key for form)
    packageTypes: [
      { value: 'full-camp', title: 'Full Camp Package', desc: 'Facilities + Accommodation + Meals + Transport' },
      { value: 'facilities-only', title: 'Facilities Only', desc: 'Training facilities booking only' },
      { value: 'custom', title: 'Custom Package', desc: 'Select specific services below' },
    ],
    // Services: value must match form logic (e.g. 'accommodation', 'meals-(breakfast,-lunch,-dinner)')
    servicesList: [
      { value: 'facility-booking', label: 'Facility Booking' },
      { value: 'accommodation', label: 'Accommodation' },
      { value: 'meals-(breakfast,-lunch,-dinner)', label: 'Meals (Breakfast, Lunch, Dinner)' },
      { value: 'airport-transportation', label: 'Airport Transportation' },
      { value: 'local-transportation', label: 'Local Transportation' },
      { value: 'equipment-rental', label: 'Equipment Rental' },
      { value: 'sports-medicine-support', label: 'Sports Medicine Support' },
      { value: 'video-analysis', label: 'Video Analysis' },
      { value: 'coaching-support', label: 'Coaching Support' },
      { value: 'other', label: 'Other' },
    ],
    accommodationTypes: [
      { value: 'hotel-3', label: 'Hotel (3-star)' },
      { value: 'hotel-4', label: 'Hotel (4-star)' },
      { value: 'sports-residence', label: 'Sports Residence' },
      { value: 'no-preference', label: 'No Preference' },
    ],
    mealPrefsList: [
      { value: 'vegetarian-options-needed', label: 'Vegetarian options needed' },
      { value: 'vegan-options-needed', label: 'Vegan options needed' },
      { value: 'halal-options-needed', label: 'Halal options needed' },
      { value: 'gluten-free-options-needed', label: 'Gluten-free options needed' },
      { value: 'food-allergies', label: 'Food allergies (specify below)' },
    ],
    consent: {
      privacy: 'I agree to the',
      privacyLink: 'privacy policy',
      and: 'and',
      termsLink: 'terms of service',
      helpText: "We'll use your information only to process your booking and communicate with you about your training camp.",
      marketing: "Yes, I'd like to receive updates about training camps and special offers",
    },
    submit: 'Submit Booking Request',
    submitting: 'Submitting...',
    helpLink: 'Need help? Contact us directly',
    whyBook: 'Why Book With Champion Maker?',
    benefits: [
      { title: '24-Hour Response', desc: 'Quick confirmation and personalized quotes' },
      { title: 'Trusted Service', desc: '50+ successful training camps organized' },
      { title: 'Full Support', desc: 'Dedicated team throughout your camp' },
    ],
    faqHeading: 'Common Questions',
    faq: [
      { question: 'How far in advance should I book?', answer: 'We recommend booking at least 2-3 months in advance, especially for peak season (May-September).' },
      { question: "What's included in the Full Camp Package?", answer: 'Facility booking, accommodation, all meals, airport transfers, local transportation, and equipment rental.' },
      { question: 'Can I customize my package?', answer: 'Absolutely! We offer flexible packages tailored to your specific needs.' },
      { question: 'What payment methods do you accept?', answer: 'We accept bank transfers, credit cards, and can provide payment plans for larger bookings.' },
      { question: 'Is there a minimum group size?', answer: 'We can accommodate groups of all sizes, from 10 to 100+ athletes.' },
    ],
    // Options for selects (value preserved)
    countryOptions: [
      { value: '', label: 'Select your country' },
      { value: 'BG', label: 'Bulgaria' },
      { value: 'US', label: 'United States' },
      { value: 'GB', label: 'United Kingdom' },
      { value: 'DE', label: 'Germany' },
      { value: 'FR', label: 'France' },
      { value: 'IT', label: 'Italy' },
      { value: 'ES', label: 'Spain' },
      { value: 'NL', label: 'Netherlands' },
      { value: 'BE', label: 'Belgium' },
      { value: 'CH', label: 'Switzerland' },
      { value: 'AT', label: 'Austria' },
      { value: 'GR', label: 'Greece' },
      { value: 'RO', label: 'Romania' },
      { value: 'TR', label: 'Turkey' },
      { value: 'KW', label: 'Kuwait' },
      { value: 'QA', label: 'Qatar' },
      { value: 'BH', label: 'Bahrain' },
      { value: 'OM', label: 'Oman' },
      { value: 'SA', label: 'Saudi Arabia' },
      { value: 'AE', label: 'United Arab Emirates' },
      { value: 'IQ', label: 'Iraq' },
      { value: 'OTHER', label: 'Other' },
    ],
    sportOptions: [
      { value: '', label: 'Select sport/discipline' },
      { value: 'basketball', label: 'Basketball' },
      { value: 'volleyball', label: 'Volleyball' },
      { value: 'football', label: 'Football/Soccer' },
      { value: 'swimming', label: 'Swimming' },
      { value: 'water-polo', label: 'Water Polo' },
      { value: 'artistic-swimming', label: 'Artistic Swimming' },
      { value: 'athletics', label: 'Athletics' },
      { value: 'track-field', label: 'Track & Field' },
      { value: 'multi-sport', label: 'Multi-Sport' },
      { value: 'other', label: 'Other' },
    ],
    locationOptions: [
      { value: '', label: 'Select preferred location' },
      { value: 'sofia-mladost', label: 'Sofia, Mladost (Basketball, Volleyball)' },
      { value: 'sofia-nsa', label: 'Sofia, NSA (Athletics)' },
      { value: 'plovdiv', label: 'Plovdiv (Swimming, Water Polo)' },
      { value: 'sofia-boyana', label: 'Sofia, Boyana (Multi-Sport)' },
      { value: 'kranevo', label: 'Kranevo (Beach Sports, Multi-Sport)' },
      { value: 'no-preference', label: 'No Preference' },
    ],
    hearAboutUsOptions: [
      { value: '', label: 'Select an option' },
      { value: 'google', label: 'Google Search' },
      { value: 'social-media', label: 'Social Media' },
      { value: 'referral', label: 'Referral' },
      { value: 'previous-customer', label: 'Previous Customer' },
      { value: 'sports-organization', label: 'Sports Organization' },
      { value: 'other', label: 'Other' },
    ],
    budgetOptions: [
      { value: '', label: 'Select budget range' },
      { value: 'under-5000', label: 'Under €5,000' },
      { value: '5000-10000', label: '€5,000 - €10,000' },
      { value: '10000-20000', label: '€10,000 - €20,000' },
      { value: '20000-50000', label: '€20,000 - €50,000' },
      { value: 'above-50000', label: 'Above €50,000' },
      { value: 'prefer-discuss', label: 'Prefer to Discuss' },
    ],
  },
  ar: {
    breadcrumb: { home: 'الرئيسية', bookNow: 'احجز الآن' },
    hero: {
      title: 'احجز معسكرك التدريبي',
      subheading: 'أكمل النموذج أدناه وسيتواصل معك فريقنا خلال 24 ساعة',
      description: 'اختر المنشأة والتواريخ ومتطلبات التدريب. نحن نعالج كل شيء آخر.',
    },
    success: {
      title: 'شكراً لك! تم استلام طلب الحجز',
      message: 'استلمنا طلب الحجز. سيتواصل معك فريقنا قريباً لتأكيد التفاصيل وتقديم عرض سعر.',
      returnHome: 'العودة إلى الصفحة الرئيسية',
    },
    sections: {
      contact: 'معلومات الاتصال',
      trainingCamp: 'تفاصيل المعسكر التدريبي',
      packageServices: 'الباقة والخدمات المطلوبة',
      additional: 'تفاصيل إضافية',
    },
    labels: {
      fullName: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      organization: 'اسم المنظمة/الفريق',
      country: 'الدولة',
      sport: 'الرياضة/التخصص',
      location: 'الموقع المفضل',
      numAthletes: 'عدد الرياضيين',
      numCoaches: 'عدد المدربين/الطاقم',
      startDate: 'تاريخ البدء المفضل',
      endDate: 'تاريخ الانتهاء المفضل',
      packageType: 'نوع الباقة',
      servicesNeeded: 'الخدمات المطلوبة',
      accommodationType: 'نوع الإقامة',
      mealPreferences: 'تفضيلات الوجبات',
      specialRequirements: 'متطلبات أو طلبات خاصة',
      hearAboutUs: 'كيف سمعت عنا؟',
      budgetRange: 'نطاق الميزانية (اختياري)',
    },
    placeholders: {
      fullName: 'اسمك الكامل',
      email: 'your.email@example.com',
      phone: '+359 XXX XXX XXX',
      organization: 'اسم فريقك أو منظمتك',
      country: 'اختر دولتك',
      sport: 'اختر الرياضة/التخصص',
      sportOther: 'يرجى التحديد',
      location: 'اختر الموقع المفضل',
      numAthletes: 'مثال: 20',
      numCoaches: 'مثال: 3',
      specialRequirements: 'يرجى مشاركة أي متطلبات محددة أو أهداف تدريبية أو احتياجات خاصة أو أسئلة...',
      hearAboutUs: 'اختر خياراً',
      budgetRange: 'اختر نطاق الميزانية',
      foodAllergies: 'يرجى تحديد حساسيات الطعام',
    },
    errors: {
      fullNameRequired: 'الاسم الكامل مطلوب',
      emailRequired: 'البريد الإلكتروني مطلوب',
      emailInvalid: 'يرجى إدخال بريد إلكتروني صحيح',
      phoneRequired: 'رقم الهاتف مطلوب',
      sportRequired: 'يرجى اختيار رياضة/تخصص',
      locationRequired: 'يرجى اختيار الموقع المفضل',
      numAthletesRequired: 'يرجى إدخال عدد الرياضيين (على الأقل 1)',
      startDateRequired: 'تاريخ البدء مطلوب',
      endDateRequired: 'تاريخ الانتهاء مطلوب',
      endDateAfterStart: 'يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء',
      privacyRequired: 'يجب الموافقة على سياسة الخصوصية',
    },
    duration: 'المدة:',
    nights: 'ليالي',
    days: 'أيام',
    required: '*',
    packageTypes: [
      { value: 'full-camp', title: 'باقة المعسكر الكاملة', desc: 'منشآت + إقامة + وجبات + نقل' },
      { value: 'facilities-only', title: 'المنشآت فقط', desc: 'حجز منشآت التدريب فقط' },
      { value: 'custom', title: 'باقة مخصصة', desc: 'اختر الخدمات المحددة أدناه' },
    ],
    servicesList: [
      { value: 'facility-booking', label: 'حجز المنشأة' },
      { value: 'accommodation', label: 'الإقامة' },
      { value: 'meals-(breakfast,-lunch,-dinner)', label: 'الوجبات (فطور، غداء، عشاء)' },
      { value: 'airport-transportation', label: 'النقل من المطار' },
      { value: 'local-transportation', label: 'النقل المحلي' },
      { value: 'equipment-rental', label: 'تأجير المعدات' },
      { value: 'sports-medicine-support', label: 'دعم الطب الرياضي' },
      { value: 'video-analysis', label: 'تحليل الفيديو' },
      { value: 'coaching-support', label: 'دعم التدريب' },
      { value: 'other', label: 'أخرى' },
    ],
    accommodationTypes: [
      { value: 'hotel-3', label: 'فندق (3 نجوم)' },
      { value: 'hotel-4', label: 'فندق (4 نجوم)' },
      { value: 'sports-residence', label: 'سكن رياضي' },
      { value: 'no-preference', label: 'بدون تفضيل' },
    ],
    mealPrefsList: [
      { value: 'vegetarian-options-needed', label: 'خيارات نباتية' },
      { value: 'vegan-options-needed', label: 'خيارات نباتية صرفة' },
      { value: 'halal-options-needed', label: 'خيارات حلال' },
      { value: 'gluten-free-options-needed', label: 'خيارات خالية من الغلوتين' },
      { value: 'food-allergies', label: 'حساسيات طعام (حدد أدناه)' },
    ],
    consent: {
      privacy: 'أوافق على',
      privacyLink: 'سياسة الخصوصية',
      and: 'و',
      termsLink: 'شروط الخدمة',
      helpText: 'سنستخدم معلوماتك فقط لمعالجة حجزك والتواصل معك بخصوص معسكرك التدريبي.',
      marketing: 'نعم، أود تلقي تحديثات عن المعسكرات التدريبية والعروض الخاصة',
    },
    submit: 'إرسال طلب الحجز',
    submitting: 'جاري الإرسال...',
    helpLink: 'تحتاج مساعدة؟ تواصل معنا مباشرة',
    whyBook: 'لماذا تحجز مع صناع الأبطال؟',
    benefits: [
      { title: 'رد خلال 24 ساعة', desc: 'تأكيد سريع وعروض مخصصة' },
      { title: 'خدمة موثوقة', desc: 'أكثر من 50 معسكر تدريبي ناجح' },
      { title: 'دعم كامل', desc: 'فريق مخصص طوال معسكرك' },
    ],
    faqHeading: 'أسئلة شائعة',
    faq: [
      { question: 'كم مقدماً يجب أن أحجز؟', answer: 'نوصي بالحجز قبل شهرين إلى 3 أشهر على الأقل، وخاصة في موسم الذروة (أيار–أيلول).' },
      { question: 'ما المُدرج في باقة المعسكر الكاملة؟', answer: 'حجز المنشأة، الإقامة، جميع الوجبات، نقل المطار، النقل المحلي، وتأجير المعدات.' },
      { question: 'هل يمكنني تخصيص باقتي؟', answer: 'بالتأكيد! نقدم باقات مرنة مصممة حسب احتياجاتك.' },
      { question: 'ما طرق الدفع المقبولة؟', answer: 'نقبل التحويلات البنكية وبطاقات الائتمان ويمكننا توفير خطط دفع للحجوزات الأكبر.' },
      { question: 'هل هناك حد أدنى لحجم المجموعة؟', answer: 'نستوعب مجموعات بجميع الأحجام، من 10 إلى أكثر من 100 رياضي.' },
    ],
    countryOptions: [
      { value: '', label: 'اختر دولتك' },
      { value: 'BG', label: 'بلغاريا' },
      { value: 'US', label: 'الولايات المتحدة' },
      { value: 'GB', label: 'المملكة المتحدة' },
      { value: 'DE', label: 'ألمانيا' },
      { value: 'FR', label: 'فرنسا' },
      { value: 'IT', label: 'إيطاليا' },
      { value: 'ES', label: 'إسبانيا' },
      { value: 'NL', label: 'هولندا' },
      { value: 'BE', label: 'بلجيكا' },
      { value: 'CH', label: 'سويسرا' },
      { value: 'AT', label: 'النمسا' },
      { value: 'GR', label: 'اليونان' },
      { value: 'RO', label: 'رومانيا' },
      { value: 'TR', label: 'تركيا' },
      { value: 'SA', label: 'المملكة العربية السعودية' },
      { value: 'AE', label: 'الإمارات العربية المتحدة' },
      { value: 'KW', label: 'الكويت' },
      { value: 'QA', label: 'قطر' },
      { value: 'BH', label: 'البحرين' },
      { value: 'OM', label: 'عُمان' },
      { value: 'IQ', label: 'العراق' },
      { value: 'OTHER', label: 'أخرى' },
    ],
    sportOptions: [
      { value: '', label: 'اختر الرياضة/التخصص' },
      { value: 'basketball', label: 'كرة السلة' },
      { value: 'volleyball', label: 'الكرة الطائرة' },
      { value: 'football', label: 'كرة القدم' },
      { value: 'swimming', label: 'السباحة' },
      { value: 'water-polo', label: 'كرة الماء' },
      { value: 'artistic-swimming', label: 'السباحة الإيقاعية' },
      { value: 'athletics', label: 'ألعاب القوى' },
      { value: 'track-field', label: 'الجري والميدان' },
      { value: 'multi-sport', label: 'متعدد الرياضات' },
      { value: 'other', label: 'أخرى' },
    ],
    locationOptions: [
      { value: '', label: 'اختر الموقع المفضل' },
      { value: 'sofia-mladost', label: 'صوفيا، ملادوست (كرة السلة، الطائرة)' },
      { value: 'sofia-nsa', label: 'صوفيا، الأكاديمية الوطنية (ألعاب القوى)' },
      { value: 'plovdiv', label: 'بلوفديف (السباحة، كرة الماء)' },
      { value: 'sofia-boyana', label: 'صوفيا، بويانا (متعدد الرياضات)' },
      { value: 'kranevo', label: 'كرانيفو (رياضات شاطئية، متعدد الرياضات)' },
      { value: 'no-preference', label: 'بدون تفضيل' },
    ],
    hearAboutUsOptions: [
      { value: '', label: 'اختر خياراً' },
      { value: 'google', label: 'بحث غوغل' },
      { value: 'social-media', label: 'وسائل التواصل الاجتماعي' },
      { value: 'referral', label: 'إحالة' },
      { value: 'previous-customer', label: 'عميل سابق' },
      { value: 'sports-organization', label: 'منظمة رياضية' },
      { value: 'other', label: 'أخرى' },
    ],
    budgetOptions: [
      { value: '', label: 'اختر نطاق الميزانية' },
      { value: 'under-5000', label: 'أقل من 5,000 يورو' },
      { value: '5000-10000', label: '5,000 - 10,000 يورو' },
      { value: '10000-20000', label: '10,000 - 20,000 يورو' },
      { value: '20000-50000', label: '20,000 - 50,000 يورو' },
      { value: 'above-50000', label: 'أكثر من 50,000 يورو' },
      { value: 'prefer-discuss', label: 'أفضل المناقشة' },
    ],
  },
};
